import { render, staticRenderFns } from "./EventsDocumentPanel.vue?vue&type=template&id=c8608a7e"
import script from "./EventsDocumentPanel.vue?vue&type=script&lang=js"
export * from "./EventsDocumentPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports